// src/services/homePrivateService.js
//
// Load and save the home page's private cards (My notes, My quick links; UI
// revamp). Reads straight from the person's own document (only they can, by
// rule); saves go through the saveHomePrivate function, which checks every
// limit and link rule before writing (rules can't check list items).

import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";
import { getHomePrivateDocPathFor } from "./firestorePaths";
import { authedFetch } from "./authedFetch";
import { FUNCTIONS_BASE } from "../config/functionsBase";
import { normalizePrivate } from "./homePrivate";

/** The person's goals, notes and links at this site (empty if none yet). */
export const loadHomePrivate = async ({ tenantId, siteId, uid }) => {
  const snap = await getDoc(doc(db, getHomePrivateDocPathFor(tenantId, siteId, uid)));
  return normalizePrivate(snap.exists() ? snap.data() : null);
};

/** Save the whole set; throws with a readable message if the server refuses. */
export const saveHomePrivate = async ({ tenantId, siteId, data }) => {
  const res = await authedFetch(`${FUNCTIONS_BASE}/saveHomePrivate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      tenantId,
      siteId,
      today: data.today,
      week: data.week,
      notes: data.notes,
      links: data.links,
      pins: data.pins || [],
    }),
  });
  let body = {};
  try {
    body = await res.json();
  } catch {
    body = {};
  }
  if (!res.ok) {
    const err = new Error(body.error || "Couldn't save.");
    // A refusal (400) won't succeed by retrying; anything else might.
    err.retryable = res.status !== 400;
    throw err;
  }
  return body;
};
